import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import { StorageService } from '../../services/storage.service';
import { Constants } from '../../core/enums/constants.enum';
import { AuthenticationService } from '../../services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private oktaAuth: OktaAuthService,
    private router: Router,
    private storageService: StorageService,
    private authenticationService: AuthenticationService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const invalidMarketIds = ['/', '/login'];
    if (invalidMarketIds.indexOf(state.url) < 0) {
      this.storageService.setItem(Constants.RETURN_URL_KEY, state.url, 'session');
    }
    return this.oktaAuth.isAuthenticated()
      .then(
        (authenticated) => {
          if (authenticated) {
            this.authenticationService.updateAuthenticationState(true);
            return true;
          } else {
            this.authenticationService.updateAuthenticationState(false);
            this.router.navigate(['login']).catch(err => console.error(err));
            return false;
          }
        }
      )
      .catch(
        (err) => {
          console.error(err);
          return false;
        }
      );
  }
}
